import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router =  new Router({
  mode: 'history',
  base: '/',
  routes: [{
      path: '/',
      component: resolve => require(['../components/home.vue'], resolve),
      meta: {
        title: '主页框架'
      },
      children: [
        {
          path: '/',
          component: resolve => require(['../components/page/index.vue'], resolve),
          meta: {
            title: '890巴九灵'
          },
        },
        {
          path: '/app',
          component: resolve => require(['../components/page/xsxapp.vue'], resolve),
          meta: {
            title: '吴晓波频道App_890巴九灵',
          },
        },
        {
          path: '/wxbpd',
          component: resolve => require(['../components/page/wxbpd.vue'], resolve),
          meta: {
            title: '吴晓波频道_890巴九灵'
          },
        },
        {
          path: '/jdsx',
          component: resolve => require(['../components/page/jdsx.vue'], resolve),
          meta: {
            title: '吴晓波频道_激荡商学'
          },
        },
        {
          path: '/xsszzx',
          component: resolve => require(['../components/page/xsszzx.vue'], resolve),
          meta: {
            title: '吴晓波频道_芯所数智中心'
          },
        },
        {
            path: '/mttjwxb',
            component: resolve => require(['../components/page/mttjwxb.vue'], resolve),
            meta: {
              title: '每天听见吴晓波_890巴九灵'
            }
        },
        {
            path: '/qjwqrcpyjh',
            component: resolve => require(['../components/page/qjwqrcpyjh.vue'], resolve),
            meta: {
              title: '千家万企人才培养计划_890巴九灵'
            }
        },
        {
            path: '/chqqfh',
            component: resolve => require(['../components/page/chqqfh.vue'], resolve),
            meta: {
              title: '出海全球峰会_890巴九灵'
            }
        },
        {
            path: '/dsxlk',
            component: resolve => require(['../components/page/dsxlk.vue'], resolve),
            meta: {
              title: '大师系列课_890巴九灵'
            }
        },
        {
            path: '/wxbnzx',
            component: resolve => require(['../components/page/wxbnzx.vue'], resolve),
            meta: {
              title: '吴晓波年终秀_890巴九灵'
            }
        },
        {
          path: '/bps',
          component: resolve => require(['../components/page/bps.vue'], resolve),
          meta: {
            title: '白皮书系列_890巴九灵'
          }
      },
      {
        path: '/sp',
        component: resolve => require(['../components/page/sp.vue'], resolve),
        meta: {
          title: '视频系列_890巴九灵'
        }
      },
      {
        path: '/xxzx',
        component: resolve => require(['../components/page/xxzx.vue'], resolve),
        meta: {
          title: '新鲜资讯_890巴九灵'
        }
      },
      {
        path: '/gsjs',
        component: resolve => require(['../components/page/gsjs.vue'], resolve),
        meta: {
          title: '公司介绍_890巴九灵'
        }
      },
      {
        path: '/dsj',
        component: resolve => require(['../components/page/dsj.vue'], resolve),
        meta: {
          title: '荣誉&大事件_890巴九灵'
        }
      }
      ],

    },],
});
router.beforeEach((to, from, next) => {

  /* 路由发生变化修改页面title */
  if (to.meta.title) {
      document.title = to.meta.title;
  }
  next();

});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js